import React, { useEffect, useState } from 'react';

import { Button, Divider, Grid, Step, StepButton, Stepper, Typography } from '@material-ui/core';
import { TabControl, Dialog } from 'components';
import { useHistory } from 'react-router-dom';
import { Loader, Done, Market, Merchant, Summary } from './components';
import Aot from './components/Aot';
import { generateAot } from './api';

const STEPS = [
    'Sélection marché',
    'Sélection titulaire',
    'Sélection AOT',
    'Récapitulatif',
    'Génération'
];

const GenerateAot = props => {
    const [loading, setLoading] = useState(false);

    const [market, setMarket] = useState(null);
    const [merchantCount, setMerchantCount] = useState(0);
    const [merchants, setMerchants] = useState([]);
    const [activeStep, setActiveStep] = useState(0);
    const [aot, setAot] = useState(null);

    const history = useHistory();

    const isLastStep = () => {
        return activeStep === STEPS.length - 1;
    };

    const setSelectedMerchant = merchant => {
        if (Array.isArray(merchant)) {
            setMerchants(merchant);
            return;
        }

        const m = [...merchants];
        const index = m.findIndex(s => s.id === merchant.id);

        if (index > -1) {
            m.splice(index, 1);
        } else {
            m.push(merchant);
        }

        setMerchants(m);
    };

    const notNextable = () => {
        if (activeStep === 0) {
            return true;
        }

        if (activeStep === 1) {
            return loading || merchants.length === 0;
        }

        if (activeStep === 2) {
            return loading || aot === null;
        }

        if (activeStep === 3) {
            return loading || aot === null;
        }
    };

    const validate = () => {
        generateAot(
            aot.id,
            aot.text,
            aot.label,
            market.id,
            merchants.map(m => m.id)
        )
            .catch(err => setActiveStep(3) || alert(err))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        if (market !== null) {
            setActiveStep(1);
        }
    }, [market]);

    useEffect(() => {
        if (activeStep === 0) {
            setMerchants([]);
            setMerchantCount(0);
        }

        if (isLastStep()) {
            setLoading(true);
            validate();
        }
    }, [activeStep]);

    return (
        <Dialog
            title="Génération des AOT"
            loading={loading}
            onClose={() => history.push('/merchants/all')}
            open
            action={
                <>
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={() => setActiveStep(activeStep - 1)}
                        disabled={activeStep === 0 || isLastStep()}>
                        Précédent
                    </Button>
                    {activeStep < 4 ? (
                        activeStep === 3 ? (
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={() => setActiveStep(activeStep + 1)}>
                                Générer et envoyer
                            </Button>
                        ) : (
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={() => setActiveStep(activeStep + 1)}
                                disabled={notNextable()}>
                                Suivant
                            </Button>
                        )
                    ) : null}
                </>
            }>
            <Grid container direction="column" spacing={0}>
                <Grid item>
                    <Stepper
                        alternativeLabel
                        nonLinear
                        activeStep={activeStep}
                        style={{ padding: 7 }}>
                        {STEPS.map((label, index) => (
                            <Step key={label}>
                                <StepButton
                                    onClick={() => setActiveStep(index)}
                                    completed={index < activeStep}
                                    disabled={index > activeStep || isLastStep()}>
                                    {label}
                                </StepButton>
                            </Step>
                        ))}
                    </Stepper>
                </Grid>
                <Grid item>
                    <TabControl value={activeStep} index={0}>
                        <Market setMarket={setMarket} />
                    </TabControl>
                    <TabControl value={activeStep} index={1}>
                        <Merchant
                            setMerchantCount={setMerchantCount}
                            merchantCount={merchantCount}
                            market={market}
                            selectedMerchants={merchants}
                            setSelectedMerchants={setSelectedMerchant}
                        />
                    </TabControl>
                    <TabControl value={activeStep} index={2}>
                        <Aot
                            selectedAot={aot}
                            setSelectedAot={setAot}
                            market={market}
                            merchantCount={merchantCount}
                            selectedMerchants={merchants}
                        />
                    </TabControl>
                    <TabControl value={activeStep} index={3}>
                        <Summary
                            market={market}
                            merchants={merchants}
                            setAot={setAot}
                            aot={aot}
                            setMerchants={setSelectedMerchant}
                            merchantCount={merchantCount}
                        />
                    </TabControl>
                    <TabControl value={activeStep} index={4}>
                        {loading ? <Loader /> : <Done />}
                    </TabControl>
                </Grid>
            </Grid>
        </Dialog>
    );
};

export default GenerateAot;
